<template>
  <div>
    <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>
    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <b-card>
      <b-row>
        <div class="col-12 mt-3">
          <b-form @submit.prevent="updateAsset" v-if="show">
            <!-- Heading -->
            <div style="background-color:#617498; height:32px; border-radius:4px;">
              <h4 style="color:#dfe3ee; margin-left:5px; font-weight:bold;">
                Update Asset
              </h4>
            </div>

            <div class="row">
              <!-- Asset Name -->
               <!-- <div class="col-md-4 col-12">
                <b-form-group label="Asset Name:" label-for="name">
                  <b-form-input id="name" v-model="asset.name" required />
                </b-form-group>
              </div> -->

              <!-- Type -->
               <!-- <div class="col-md-4 col-12">
                <b-form-group label="Type:" label-for="type">
                  <b-form-select id="type" v-model="asset.type" :options="types" required />
                </b-form-group>
              </div> -->

              <!-- Current Company Worth Value  -->
              <div class="col-md-4 col-12">
                <b-form-group label="Current Company Worth Value:" label-for="value">
                  <b-form-input id="value" type="number" v-model="asset.value" required />
                </b-form-group>
              </div>
            
              <!-- Status -->
              <!-- <div class="col-md-4 col-12">
                <b-form-group label="Status:" label-for="status">
                  <b-form-select id="status" v-model="status" :options="statuses" required />
                </b-form-group>
              </div> -->

              <!-- Purchase Date -->
              <!-- <div class="col-md-4 col-12">
                <b-form-group label="Purchase Date:" label-for="purchase_date">
                  <b-form-input id="purchase_date" type="date" v-model="purchase_date" />
                </b-form-group>
              </div> -->

              <!-- Document -->
             <!--  <div class="col-md-6 col-12">
                <b-form-group label="Document:" label-for="document">
                  <div v-if="asset.document_url">
                    <a :href="asset.document_url" target="_blank">
                      <i class="fas fa-file" style="margin-right:5px;"></i> View Document
                    </a>
                  </div>
                  <input type="file" @change="onDocumentChange"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.jpg,.png" />
                </b-form-group>
              </div> -->
            </div>

            <!-- Submit -->
            <b-button type="submit" variant="primary" class="mb-3" :disabled="isLoading">
              <span v-if="!isLoading">Update</span>
              <b-spinner v-else small></b-spinner>
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import axios from "@/axios";

export default {
  data() {
    return {
      show: true,
      isLoading: false,
      successMessage: "",
      errorMessage: "",

      asset: {
        id: null,
        name: "",
        type: "",
        value: "",
        document: null,
        document_url: "",
      },

      types: [
        { value: "Fixed", text: "Fixed" },
        { value: "Current", text: "Current" },
        { value: "Intangible", text: "Intangible" },
        { value: "Financial", text: "Financial" },
      ],
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BSpinner,
  },
  created() {
    // const id = this.$route.params.id; // asset id from route
    const id = 1; // asset id from route
    axios
      .get(`assets/${id}`)
      .then((res) => {
        const data = res.data.data;
        this.asset.id = data.id;
        this.asset.name = data.name;
        this.asset.type = data.type;
        this.asset.value = data.value;
        this.asset.document_url = data.document
          ? `https://wossdb.wossautoid.com/${data.document}`
          : "";
      })
      .catch(() => {
        this.errorMessage = "Asset details not found.";
      });
  },
  methods: {
    updateAsset() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("name", this.asset.name);
      formData.append("type", this.asset.type);
      formData.append("value", this.asset.value);
      if (this.asset.document instanceof File) {
        formData.append("document", this.asset.document);
      }

      axios
        .post(`assetsUpdate/${this.asset.id}`, formData)
        .then(() => {
          this.$bvToast.toast("Asset updated successfully!", {
            title: "Success",
            variant: "success",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.isLoading = false;
          this.$router.push({ name: "ListStakeholder" }); // back to stakeholder list
        })
        .catch(() => {
          this.errorMessage = "Error updating asset.";
          this.isLoading = false;
        });
    },
    onDocumentChange(event) {
      const file = event.target.files[0];
      if (file) this.asset.document = file;
    },
  },
};
</script>
